export const YES_NO = 'yes_no';
export const yesNoIcons = [
  { id: 'check_and_x', label: 'Check and X' },
  { id: 'faces', label: 'Faces' },
  { id: 'glasses_of_water', label: 'Glasses of Water' },
  { id: 'ice_box', label: 'Ice Cream Cone' },
  { id: 'lightbulb', label: 'Lightbulb' },
  { id: 'mood_weather', label: 'Mood Weather' },
  { id: 'pizza_box', label: 'Pizza Box' },
  { id: 'red_rose', label: 'Red Rose' },
  { id: 'snowman', label: 'Snowman' },
  { id: 'thumbs', label: 'Thumbs' },
  { id: 'toilet_paper', label: 'Toilet Paper' },
];
